import React, { useState } from 'react'
import './index.css'
import { Row, Col, Typography, Flex, Card } from 'antd'
import { UnderlineDesign } from '../UnderlineDesign'

const { Text, Title, Paragraph } = Typography
const Teamcomponent = () => {

    const [ expanded, setExpanded ] = useState(false)
    const data = [
        {
            img:'t-1.jpg',
            title:'Jackson',
            subtitle:'CTO',
        },
        {
            img:'t-2.jpg',
            title:'Juliya',
            subtitle:'Project Manager',
        },
        {
            img:'t-3.png',
            title:'Sadia',
            subtitle:'Ceo',
        },
        {
            img:'t-4.png',
            title:'Zarqa',
            subtitle:'Marketing specialist',
        },
    ]

    return (
        <div className='padding-t mb-3'>
            <div className='container'>
                <Row gutter={[24, 24]}>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} xl={{ span: 24 }}>
                        <Flex vertical align='center'>
                            <Title level={2} className='m-0 gradient-text'>Our Team Member</Title>
                            <UnderlineDesign />
                        </Flex>
                    </Col>
                    {
                        data?.map((details,index)=>
                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} xl={{ span: 6 }} className='employee-1' key={index}>
                                {/* <div className="employee">
                                    <div className="employee-image">
                                        <img src={'/assets/images/'+details?.img} alt="employee-image" />
                                    </div>
                                    <div className="employee-details">
                                        <div className="employee-name">
                                            <Title level={5} className="text-white text-center m-0">{details?.title}</Title>
                                            <Title level={5} className='text-white text-center m-0'>{details?.subtitle}</Title>
                                        </div>
                                        <div className="employee-social-link">
                                            <ul>
                                                {
                                                    details?.social?.map((sociallink, i)=>
                                                        <li key={i}>
                                                            <Link to={sociallink?.path}>
                                                                <img src={"/assets/icons/"+sociallink?.icons} width={24} alt="" />
                                                            </Link>
                                                        </li>
                                                    )
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </div> */}
                                <Card className='card-cs bg-dark-brown rounded h-100' >
                                    <img src={'/assets/images/'+details?.img} width={'100%'} className='rounded img-pro' />
                                    <Flex vertical className='my-2 center' align='center'>
                                        <Title level={5} className='m-0 '>
                                            {
                                                details?.title
                                            }
                                        </Title>
                                        <Text className='fs-14'>
                                            {
                                                details?.subtitle
                                            }
                                        </Text>
                                    </Flex>
                                    {/* <Paragraph
                                        ellipsis={{
                                            rows: 3,
                                            expandable: 'collapsible',
                                            symbol: expanded ? 'less' : 'more',
                                            onExpand: ()=> setExpanded(!expanded)
                                        }}
                                        className='text-gray text-justify m-0'
                                    >
                                        {
                                            details?.description
                                        }
                                    </Paragraph> */}
                                </Card>
                            </Col>
                        )
                    }
                </Row>
            </div>
        </div>
    )
}

export { Teamcomponent }